import React, { useEffect, useState } from 'react'
import WebMain from './WebMain'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useBnsXiangMuBanBenLogQuery } from '../store/BnsKeJiApi'
import { Breadcrumb, Button, Divider, Flex, Space } from 'antd'
import { BulbOutlined, ClockCircleOutlined, UserOutlined } from '@ant-design/icons'
import { h5SketchClient, h5SketchProject } from './h5Routes'

function SketchLogs() {
    const navigate = useNavigate()
    const [param] = useSearchParams()
    const bxmbb_id = param.get('bxmbb_id')
    const bxm_id = param.get('bxm_id')
    const bxm_name = param.get('bxm_name')
    const bxmxq_name = param.get('bxmxq_name')
    const bxmbb_name = param.get('bxmbb_name')
    const yh_name = param.get('yh_name')
    const yh_id = param.get('yh_id')
    const { data, isSuccess } = useBnsXiangMuBanBenLogQuery({ bxmbb_id }, { skip: !bxmbb_id })
    const [logs, setLogs] = useState([])
    useEffect(() => {
        if (isSuccess) {
            if (data.Status === 'success') {
                setLogs(data.Result)
            }
        }
    }, [isSuccess, data])

    return (
        <WebMain>
            <div style={{ width: '100%', padding: '0 12px 24px' }}>
                <span
                    role="link"
                    tabIndex={0}
                    onClick={() => navigate(h5SketchProject(bxm_id))}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') navigate(h5SketchProject(bxm_id))
                    }}
                    style={{ textAlign: 'center', color: '#fff', fontSize: 18, fontWeight: 'bold', display: 'block' }}
                >
                    {bxm_name}
                </span>
                <div
                    style={{
                        width: '100%',
                        maxWidth: '100%',
                        backgroundColor: '#fff',
                        padding: 12,
                        borderRadius: 8,
                        marginTop: 12,
                    }}
                >
                    <Flex vertical gap={12}>
                        <Breadcrumb
                            items={[
                                { title: <a onClick={() => navigate(h5SketchProject(bxm_id))}>首页</a> },
                                { title: yh_name },
                                { title: bxmxq_name },
                                { title: bxmbb_name },
                                { title: '修改日志' },
                            ]}
                        />
                        <Button
                            type="primary"
                            block
                            onClick={() =>
                                navigate(
                                    h5SketchClient({
                                        yh_id,
                                        yh_name,
                                        bxm_id,
                                        bxm_name,
                                    })
                                )
                            }
                        >
                            返回上一级
                        </Button>
                    </Flex>
                    {logs.map((log) => (
                        <div key={log.bbl_id} style={{ marginTop: 20 }}>
                            <Space wrap>
                                <ClockCircleOutlined /> {log.bbl_ctime} <UserOutlined /> {log.bbl_cname}
                            </Space>
                            <div style={{ textAlign: 'center', marginTop: 12 }}>
                                <img
                                    src={`/api/assets/images/application/${log.bbl_image || log.bbl_name}`}
                                    alt={log.bbl_name || ''}
                                    style={{
                                        width: '100%',
                                        maxWidth: '100%',
                                        height: 'auto',
                                        objectFit: 'cover',
                                        display: 'block',
                                        margin: '0 auto',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                        border: '2px #000 solid',
                                    }}
                                    onError={(e) => {
                                        e.target.src = '/img/home/logo.png'
                                    }}
                                />
                            </div>
                            <Space direction="vertical" style={{ marginTop: 12, fontSize: 15, lineHeight: 1.6, color: '#000', width: '100%' }}>
                                <BulbOutlined />
                                <div dangerouslySetInnerHTML={{ __html: log.bbl_content }} />
                            </Space>
                            <Divider />
                        </div>
                    ))}
                </div>
            </div>
        </WebMain>
    )
}

export default SketchLogs
